// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._52s5Df4sx{max-width:240px;padding:0px;padding-left:13px;overflow:hidden}._52s5Df4sx.pPd4dKeWx{height:48px;margin:0px 0}._2Eabbpf7x{margin-right:10px;transition:margin 200ms cubic-bezier(0.165, 0.84, 0.44, 1)}.ePxtCcOex{font-weight:normal;line-height:20px;display:none}._6Vc21AHUx{color:var(--secondary-text-invert);margin-bottom:0;margin-top:1px;font-size:12px}._21D1LIvox{color:var(--primary-text);margin:0;font-weight:bold;font-size:16px}._2ZiGNTfux._52s5Df4sx{padding:0 16px 0 13px}._2ZiGNTfux ._6Vc21AHUx{display:block}._2ZiGNTfux ._21D1LIvox{display:block}._2ZiGNTfux ._32EqQtA4x{margin-left:4px}._7AVR8mF2x{flex-grow:1;display:flex;justify-content:space-between;padding-right:1px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"info-container": "_52s5Df4sx",
	"infoContainer": "_52s5Df4sx",
	"new-nav": "pPd4dKeWx",
	"newNav": "pPd4dKeWx",
	"app-icon": "_2Eabbpf7x",
	"appIcon": "_2Eabbpf7x",
	"text": "ePxtCcOex " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"owner-name": "_6Vc21AHUx ePxtCcOex " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"ownerName": "_6Vc21AHUx ePxtCcOex " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"app-name": "_21D1LIvox ePxtCcOex " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"appName": "_21D1LIvox ePxtCcOex " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"expanded": "_2ZiGNTfux",
	"platform-tag": "_32EqQtA4x",
	"platformTag": "_32EqQtA4x",
	"app-info-and-platform": "_7AVR8mF2x",
	"appInfoAndPlatform": "_7AVR8mF2x"
};
module.exports = exports;
